import { Wordmark } from "@/components/brand/wordmark";
import { ReactNode } from "react";

interface AcceptInviteShellProps {
  title?: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

export function AcceptInviteShell({
  title,
  subtitle,
  children,
}: AcceptInviteShellProps) {
  return (
    <main className="relative flex min-h-dvh flex-col justify-center overflow-hidden bg-gradient-to-b from-[#ffede6] to-[#faf6ef] px-6 py-12">
      <div className="relative mx-auto w-full max-w-md">
        <Wordmark className="h-5 text-black" />
        {title && (
          <h1 className="mt-8 text-[27px] font-semibold leading-[1.12] tracking-tight text-balance text-black">
            {title}
          </h1>
        )}
        {subtitle && (
          <p className="mt-2 text-[15px] leading-relaxed text-muted-foreground text-pretty">
            {subtitle}
          </p>
        )}
        {children}
      </div>
    </main>
  );
}
